import { render, staticRenderFns } from "./UnauthenticatedUserLayout.vue?vue&type=template&id=966bdfd6&scoped=true&"
import script from "./UnauthenticatedUserLayout.vue?vue&type=script&lang=js&"
export * from "./UnauthenticatedUserLayout.vue?vue&type=script&lang=js&"
import style0 from "./UnauthenticatedUserLayout.vue?vue&type=style&index=0&id=966bdfd6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "966bdfd6",
  null
  
)

export default component.exports